import styled from 'styled-components';

export const ErrorMessage = styled.div`
    margin-top: 8px;
    color: ${p => p.theme.negative};
    font-size: ${p => p.theme.fontSize.small};
`;